const responseState = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export default function(raw = {}) {
    let response;
    if (raw && raw.status !== 'success') {
        const {error_text, error_description} = raw.data || {};

        response = {
            ...raw,
            status: responseState.ERROR,
            message: error_text || error_description || raw.message,
        };
    } else {
        response = {
            status: responseState.SUCCESS,
            data: raw ? raw.data : raw,
        };
    }

    return response;
}
